module.exports = __webpack_public_path__ + "components/wind-icon/static/NNE@2x-a6022522e69f81abdefa6bb0b0aa02ee.png";